import { Component, ViewEncapsulation } from '@angular/core';
import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';
import { ConfigManagerService } from '@xpo-ltl/config-manager';
import { ConfigManagerPropertiesEnum } from './enums/config-manager-properties.enum';
import { XpoLtlAuthenticationService } from '@xpo-ltl/ngx-auth';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class AppComponent {
  title = 'app';

  public isProduction = false;

  constructor(
    private configManagerService: ConfigManagerService,
    private iconRegistry: MatIconRegistry,
    private sanitizer: DomSanitizer,
    private authService: XpoLtlAuthenticationService
  ) {
    iconRegistry.addSvgIcon('xpo-logo', sanitizer.bypassSecurityTrustResourceUrl('./assets/images/xpo_logo.svg'));

    this.isProduction = this.configManagerService.getSetting<boolean>(ConfigManagerPropertiesEnum.Production);

    const region = this.configManagerService.getSetting<string>(ConfigManagerPropertiesEnum.Region);
    this.authService.initAuthSetup$(region).subscribe((info) => {
      if (info) {
        this.userLogin();
      }
    });
  }

  private userLogin(): void {
    // User is authenticated via SSO at this point
    // Additional user setup can be handled by the LoggedInUserResolver
  }
}
